// 30 seconds
export const LIVE_NOW_SCALE_UP_INTERVAL = 30000

// 5 minutes
export const LIVE_NOW_SCALE_DOWN_INTERVAL = 300000

// 30 seconds
export const LIVE_UPCOMING_INTERVAL = 30000
